import { INSTAGRAM, waLink, LOGO } from "@/lib/api";
import { Instagram, MessageCircle, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer
      className="border-t border-[#311B4D] bg-[#0B0410]"
      data-testid="footer"
    >
      <div className="mx-auto max-w-[1400px] px-6 py-16 md:px-12">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <img
              src={LOGO}
              alt="Elixz Chocolates"
              className="h-32 w-auto"
            />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#A894C2]">
              Exquisite handcrafted chocolates. Positioned as the gift for every
              occasion of life.
            </p>
          </div>

          <div className="space-y-3 text-sm text-[#A894C2]">
            <div className="text-xs uppercase tracking-[0.2em] text-gold">
              Reach Us
            </div>
            <a
              href={INSTAGRAM}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 transition-colors hover:text-[#FDFBF7]"
              data-testid="footer-instagram"
            >
              <Instagram size={16} /> @elixz.chocolates
            </a>
            <a
              href={waLink("Hi Elixz!")}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 transition-colors hover:text-[#FDFBF7]"
              data-testid="footer-whatsapp"
            >
              <MessageCircle size={16} /> WhatsApp Orders
            </a>
            <a
              href="tel:+919945497442"
              className="flex items-center gap-2 transition-colors hover:text-[#FDFBF7]"
              data-testid="footer-phone"
            >
              <Phone size={16} /> +91 99454 97442
            </a>
            <div className="flex items-center gap-2">
              <MapPin size={16} /> PCMC, Pune, Maharashtra
            </div>
          </div>

          <div className="space-y-3 text-sm text-[#A894C2]">
            <div className="text-xs uppercase tracking-[0.2em] text-gold">
              Occasions
            </div>
            <div>Corporate Gifting &amp; Hampers</div>
            <div>Weddings &amp; Engagements</div>
            <div>Birthdays &amp; Baby Showers</div>
            <div>Return Gifts &amp; Favors</div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-[#311B4D] pt-6 text-xs text-[#6b5a86] md:flex-row">
          <span>&copy; {new Date().getFullYear()} Elixz Chocolates. Handcrafted with love in Pune.</span>
          <a href="/admin" className="transition-colors hover:text-gold" data-testid="footer-admin">
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
